import React from "react";

const testimonials = [
  {
    text: "Mùi hương dễ chịu và đèn rất đẹp, phòng ngủ của tôi sang hẳn!",
    author: "Lan Anh",
    avatarColor: "#FCE4EC",
    rating: 5,
  },
  {
    text: "Tinh dầu chất lượng, giúp tôi thư giãn sau giờ làm việc.",
    author: "Minh Quân",
    avatarColor: "#E8F5E9",
    rating: 4,
  },
  {
    text: "Giao hàng nhanh, đóng gói cẩn thận. Rất đáng tiền.",
    author: "Kim Ngân",
    avatarColor: "#FFF3E0",
    rating: 5,
  },
  {
    text: "Sản phẩm hoạt động tốt, tôi rất hài lòng với trải nghiệm này.",
    author: "Hữu Phát",
    avatarColor: "#E3F2FD",
    rating: 4,
  },
  {
    text: "Thiết kế đẹp mắt, phù hợp với mọi không gian trong nhà.",
    author: "Thùy Dương",
    avatarColor: "#F3E5F5",
    rating: 5,
  },
  {
    text: "Mùi hương tự nhiên, không quá nồng. Tôi sẽ mua lại lần nữa.",
    author: "Văn Hùng",
    avatarColor: "#FFFDE7",
    rating: 4,
  }
];

const Star = ({ filled }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill={filled ? "#FFC107" : "none"}
    stroke="#FFC107"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M12 .587l3.668 7.431L23.5 9.75l-5.75 5.6L19.5 24 12 20.118 4.5 24l1.75-8.65L.5 9.75l7.832-1.732L12 .587z" />
  </svg>
);

const Testimonials = () => {
  return (
    <section
      id="testimonials"
      className="section testimonials"
      aria-labelledby="testimonials-title"
    >
      <div className="container">
        <h2 id="testimonials-title" className="section-title">
          Khách Hàng Nói Gì
        </h2>

        <p className="section-subtitle">
          Những trải nghiệm thực tế từ khách hàng đã sử dụng sản phẩm của chúng tôi.
        </p>

        <div className="testimonials-list" role="list">
          {testimonials.map((t, i) => (
            <article
              key={i}
              className="testimonial-card"
              role="listitem"
              tabIndex={0}
              aria-label={`Lời chứng thực của ${t.author}`}
            >
              <div className="card-header">
                <div
                  className="avatar"
                  aria-hidden="true"
                  style={{ backgroundColor: t.avatarColor }}
                >
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 24 24"
                    fill="none"
                    aria-hidden="true"
                    focusable="false"
                  >
                    <path
                      d="M12 12c2.761 0 5-2.239 5-5s-2.239-5-5-5-5 2.239-5 5 2.239 5 5 5zM4 20.5C4 16.91 7.582 14 12 14s8 2.91 8 6.5V22H4v-1.5z"
                      fill="#2d5a3d"
                      opacity="0.95"
                    />
                  </svg>
                </div>

                <div className="author-info">
                  <div className="author-name">{t.author}</div>
                  <div className="rating" aria-hidden="true">
                    {Array.from({ length: 5 }).map((_, idx) => (
                      <Star key={idx} filled={idx < t.rating} />
                    ))}
                  </div>
                </div>

                <div className="quote-icon" aria-hidden="true">
                  <svg
                    width="36"
                    height="36"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#2d5a3d"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 7H5v6a4 4 0 0 0 4 4" />
                    <path d="M19 7h-4v6a4 4 0 0 0 4 4" />
                  </svg>
                </div>
              </div>

              <p className="testimonial-text">“{t.text}”</p>

            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;